import React, { PureComponent } from 'react'
import CSSModules from 'react-css-modules'
import classNames from 'classnames/bind'

import TextLink from 'components/text_link/text_link'
import PickerSearchError from '../error/picker_search_error'

import styles from './image_picker_search.scss'

const cx = classNames.bind(styles)

class ImageSearch extends PureComponent {

	constructor() {
		super()
		this.onKeyPress = this.onKeyPress.bind(this)
		this.onSearchConfirm = this.onSearchConfirm.bind(this)
		this.onNextPageRequest = this.onNextPageRequest.bind(this)
		this.onSearchChange = this.onSearchChange.bind(this)
		this.onSearchSelection = this.onSearchSelection.bind(this)
	}

	onKeyPress(target) {
		if (target.charCode === 13) {
			this.onSearchConfirm()
		}
	}

	onSearchConfirm() {
		this.props.onSearchConfirm('image', this.props.source)
	}

	onNextPageRequest() {
		this.props.onNextPageRequest('image', this.props.source)
	}

	onSearchChange(event) {
		this.props.onSearchChange(event, 'image')
	}

	onSearchSelection(index) {
		this.props.onSearchSelection(index, 'image')
	}

	imageSearchElements() {
		if (this.props.results) {
			return (
				<ul styleName='image-results-list'>
					{
						this.props.results.map((file, index) => (
							<li
								className={cx(
									{ 'image-results-list-item': true },
									{ 'image-results-list-item--selected': this.props.selected.includes(index) }
								)}
								key={index}
								onClick={() => {
									this.onSearchSelection(index)
								}}
							>
								<div className={styles['image-results-list-item-image']} style={{ backgroundImage: 'url(' + file.thumbnail + ')' }}></div>
							</li>
						))
					}
					{this.props.showMore &&
						<div className={styles['show-more']}>
							<span className={styles['show-more-text']}>
								{'Powered by ' + this.props.source + ' -'}
							</span>
							<div className={styles['show-more-link']}>
								<TextLink onClick={this.onNextPageRequest}>show more</TextLink>
							</div>
						</div>
					}
				</ul>
			)
		} else {
			return null
		}
	}

	render() {
		return (
			<div styleName={classNames({
				'search-image': true,
			})}>
				<div styleName='search'>
					<div styleName='search-icon'>
						<div styleName='search-icon-image'>
							<svg height="36" width="36" viewBox="0 0 36 36"> <path d="M35.48 14.99c-.07-.44-.07-.44-.52-.44H19.07c-.46 0-.46 0-.46.45v6.07c0 .51 0 .51.5.51h8.88c.18 0 .32-.01.26.25-.42 1.89-1.33 3.49-2.85 4.71-.22.17-.45.34-.68.49l5.74 4.42c.29-.27.58-.55.86-.86 1.2-1.3 2.15-2.76 2.86-4.38.88-2 1.37-4.09 1.51-6.28.11-1.65.08-3.3-.21-4.94" fill="#3b7cec"/> <path d="M30.2 4.42c-1.62-1.44-3.43-2.54-5.47-3.28C22.1.18 19.4-.09 16.63.2c-1.99.22-3.88.76-5.68 1.62-2.2 1.05-4.1 2.5-5.71 4.33-1.02 1.16-1.88 2.42-2.57 3.8 0 0 0 .01-.01.02l5.91 4.54.01-.01v-.01c.05-.14.09-.27.14-.4 1.01-2.56 2.7-4.51 5.14-5.8 1.89-.99 3.9-1.33 6.02-1.09 2.05.23 3.84 1.02 5.38 2.38.27.24.26.25.51 0 1.48-1.48 2.96-2.97 4.44-4.45.37-.36.38-.37-.01-.71" fill="#e33e2b"/> <path d="M8.58 21.41c-.36-1.06-.55-2.18-.58-3.36-.02-1.22.18-2.41.58-3.55l-.01.01-5.91-4.54c-.14.28-.28.57-.4.87-.81 1.88-1.3 3.83-1.43 5.88-.11 1.65-.01 3.27.33 4.88.33 1.52.83 2.96 1.5 4.31 0 0 0 .01.01.01v.01l5.91-4.51v-.01" fill="#f1b502"/> <path d="M24.72 27.03c-2.17 1.47-4.64 1.93-7.26 1.65-2.76-.29-5.04-1.58-6.84-3.69-.93-1.1-1.61-2.29-2.04-3.57l-5.91 4.51v-.01c.67 1.35 1.53 2.62 2.56 3.79 1.85 2.11 4.07 3.7 6.67 4.76 3.06 1.25 6.23 1.58 9.5 1.13 3.46-.48 6.51-1.79 9.04-4.13 0-.01.01-.01.02-.02l-5.74-4.42" fill="#2da24c"/> </svg>
						</div>
					</div>
					<input
						styleName='search-input'
						type='text'
						placeholder={this.props.placeholder}
						onChange={this.onSearchChange}
						value={this.props.searchTextValue}
						onKeyPress={this.onKeyPress} />
					<div styleName='search-btn' onClick={this.onSearchConfirm}>
						<svg height="20" width="20" viewBox="0 0 20 20"><path styleName='color-change' d="M18.79 18.46l-6.35-6.35c1.1-1.18 1.78-2.76 1.78-4.5C14.22 3.97 11.26 1 7.61 1 3.97 1 1 3.97 1 7.61c0 3.65 2.97 6.61 6.61 6.61 1.68 0 3.21-.63 4.38-1.67l6.36 6.36c.06.06.14.09.22.09.08 0 .16-.03.22-.09.13-.13.13-.33 0-.45zM7.61 13.59c-3.3 0-5.98-2.68-5.98-5.98 0-3.3 2.68-5.98 5.98-5.98 3.3 0 5.98 2.68 5.98 5.98 0 3.3-2.68 5.98-5.98 5.98zm0 0" fill="#8b9195" stroke="#8b9195" strokeLinecap="round"/></svg>
					</div>
				</div>
				{this.props.active &&
				<div styleName='results'>
					{ this.props.results.length > 0 &&
						this.imageSearchElements()
					}
					{ this.props.hint &&
						<PickerSearchError hint={this.props.hint} />
					}
					{ this.props.message &&
						<PickerSearchError title={this.props.title} message={this.props.message} />
					}
				</div>
				}
			</div>
		)
	}

}

export default CSSModules(ImageSearch, styles, {allowMultiple: true})
